/**
 * <share-button>
 * Native Web Share when available; otherwise copies the URL to the clipboard
 * and confirms in a live region; if the clipboard is blocked, reveals a
 * readonly URL field with a copy button.
 *
 * Strings: window.accessibilityStrings.shareSuccess (theme.liquid) for the
 * copied message; the fallback labels are in the Liquid markup.
 */
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.share-button__button');
        this.message = this.querySelector('.share-button__message');
        this.fallback = this.querySelector('.share-button__fallback');
        this.input = this.querySelector('.share-button__input');
        this.copyButton = this.querySelector('.share-button__copy');
        this.url = this.dataset.url || window.location.href;
        this.title = this.dataset.title || document.title;

        this.button?.addEventListener('click', () => this.share());
        this.copyButton?.addEventListener('click', () => this.copy());
      }

      async share() {
        if (navigator.share) {
          try {
            await navigator.share({ title: this.title, url: this.url });
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }
        this.copy();
      }

      async copy() {
        try {
          await navigator.clipboard.writeText(this.url);
          this.announce(window.accessibilityStrings?.shareSuccess || 'Link copied');
        } catch (e) {
          this.showFallback();
        }
      }

      showFallback() {
        if (!this.fallback || !this.input) return;
        this.fallback.hidden = false;
        this.input.focus();
        this.input.select();
      }

      announce(text) {
        if (!this.message) return;
        this.message.textContent = text;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.message.textContent = '';
        }, 4000);
      }
    }
  );
}
